module.exports = __webpack_public_path__ + "static/media/thum_board_noimg.b3e2ced4.svg";